import React from 'react'
import { css } from '@emotion/core'
import { Button, Modal, Typography } from '@dw/helix'

export interface ConfirmationModalComponentProps {
  title: string
  message: string
  onConfirm: () => void
  onClose: () => void
}

const confirmationModalStyles = css`
  margin-top: 116px;
`

const rowStyles = css`
  :not(:last-of-type) {
    margin-bottom: 20px;
  }
`

const buttonContainerStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const buttonStyles = css`
  display: block;
  width: calc(50% - 10px);
  &:first-of-type {
    margin-right: 20px;
  }
`

const ConfirmationModal = ({ title, message, onConfirm, onClose }: ConfirmationModalComponentProps) => {
  return (
    <Modal title={title} onClose={onClose} css={confirmationModalStyles}>
      {({ close }) => (
        <>
          <div css={rowStyles}>
            <Typography type="body">{message}</Typography>
          </div>
          <div css={buttonContainerStyles}>
            <Button onClick={close} theme="secondary" css={buttonStyles}>
              GO BACK
            </Button>
            <Button
              onClick={() => {
                onConfirm()
                close()
              }}
              css={buttonStyles}
            >
              CONFIRM
            </Button>
          </div>
        </>
      )}
    </Modal>
  )
}

export default ConfirmationModal
